import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ITaskV2AssignedUser } from '@fi-app/task-v2/fi-task-v2';
import { ILightWeightObject } from '@fi-shared/models';

interface ITaskV2ViewAssigneesDialogData {
    assignedUsers: ITaskV2AssignedUser[];
    taskRoles: ILightWeightObject[];
    taskUnits: ILightWeightObject[];
}

@Component({
    selector: 'fi-task-v2-view-assignees-dialog',
    template: `
        <fi-task-v2-assignees-list
            [assignedUsers]="data.assignedUsers"
            [taskRoles]="data.taskRoles"
            [taskUnits]="data.taskUnits"
        />
    `,
    styleUrls: ['./fi-task-v2-view-assignees-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-view-assignees-dialog' },
    standalone: false,
})
export class FiTaskV2ViewAssigneesDialogComponent extends FiDialogsContentBase<ITaskV2ViewAssigneesDialogData, void> {}
